import React, {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import {logout} from "../functions/Api";
import {getTexts} from "../index";
import {hasChatroomAccess} from "../functions/ServicePrivileges";

const companyLinks = [
    {
        name: "Xinsheng",
        href: "https://xinsheng-elec.com",
        logo: "https://files.xs-global.cn/public/xinsheng-hk-scaled.webp",
    },
    {
        name: "Jamarto",
        href: "https://jamarto.com",
        logo: "https://files.xs-global.cn/public/jamarto.webp",
    },
    {
        name: "Ravalink",
        href: "https://ravalink.com",
        logo: "https://files.xs-global.cn/public/ravalink-scaled.webp",
    },

];

const socialLinks = [
    {name: "Facebook", href: "https://www.facebook.com/xinshengelec", icon: "/fb.png"},
    {name: "LinkedIn", href: "https://www.linkedin.com/company/xinsheng-electronic-co-ltd/", icon: "/ln.png"},
    {name: "YouTube", href: "https://www.youtube.com/@xinsheng-elec", icon: "/yt.png"},
];

export default function Footer({user, onLogout, lang, setLang, appVersion}) {
    const t = getTexts();
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [loggingOut, setLoggingOut] = useState(false);

    const isAdmin = user?.role === "ADMIN";
    const isAuthorizedOnly = user?.role === "AUTHORIZED_USER"
        || user?.role === "AUTHORIZED_VISITOR";
    const isExecutive = user?.position === "EXECUTIVE"
        || Number(user?.position) === 5;
    const canSeeDepartment = !isAuthorizedOnly && !isExecutive;
    const canSeeChatrooms = hasChatroomAccess(user);

    const toggleLanguage = () => {
        const nextLanguage = lang === "cn" ? "en" : "cn";
        setLang(nextLanguage);
        localStorage.setItem("lang", nextLanguage);
        window.location.reload();
    };

    const handleLogout = async () => {
        try {
            setLoggingOut(true);
            await logout();
            setShowLogoutModal(false);
            onLogout();
            navigate("/login");
        } catch (error) {
            console.error("Logout failed:", error);
        } finally {
            setLoggingOut(false);
        }
    };

    return (
        <>
            <footer className="footer-section">
                <div className="container-xl footer-grid">
                    <nav className="footer-column footer-navigation" aria-label={t.footerNavigation}>
                        <h2>{t.quickNavigation}</h2>
                        {isAdmin && <Link to="/administration">{t.administration}</Link>}
                        {canSeeDepartment && <Link to="/my-department">{t.myDepartment}</Link>}
                        <Link to="/profile">{t.myProfile}</Link>
                        <Link to="/my-department/tasks/my-task">{t.footerMyTasks}</Link>
                        {canSeeChatrooms && <Link to="/chatrooms">{t.chatroomName}</Link>}
                        {canSeeChatrooms && <Link to="/form-submissions">{t.singleMessageName}</Link>}
                        <Link to="/tutorials-and-guide">{t.footerTutorials}</Link>
                    </nav>

                    <div className="footer-column footer-brands">
                        <div className="footer-logos">
                            {companyLinks.map((company) => (
                                <a
                                    href={company.href}
                                    key={company.name}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={company.name}
                                >
                                    <img src={company.logo} alt={`${company.name} logo`}/>
                                </a>
                            ))}
                        </div>
                        <div className="footer-socials">
                            {socialLinks.map((social) => (
                                <a
                                    href={social.href}
                                    key={social.name}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={social.name}
                                >
                                    <img src={social.icon} alt=""/>
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="footer-column footer-actions">
                        <p>{t.appVersion}: {appVersion}</p>
                        <div className="footer-buttons">
                            <button type="button" className="footer-language-btn" onClick={toggleLanguage}>
                                {lang === "cn" ? "English" : "中文"}
                            </button>
                            <button
                                type="button"
                                className="footer-logout-btn"
                                onClick={() => setShowLogoutModal(true)}
                            >
                                {t.logout}
                            </button>
                        </div>
                    </div>
                </div>
            </footer>

            <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t.logoutConfirmTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t.logoutConfirmMessage}</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowLogoutModal(false)}
                        disabled={loggingOut}
                    >
                        {t.logoutCancel}
                    </Button>
                    <Button variant="danger" onClick={handleLogout} disabled={loggingOut}>
                        {loggingOut ? t.loggingOut : t.logoutConfirm}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
